import React, { useState, useEffect } from 'react';
import api from '../api';
import { Search } from 'lucide-react';
import { format } from 'date-fns';

export const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await api.get('/admin/transactions');
      setTransactions(response.data.data?.transactions || response.data.data || []);
    } catch (error) {
      console.error(error);
      // Fallback
      setTransactions([
        { id: '1', type: 'CONTRIBUTION', amount: 150, status: 'COMPLETED', createdAt: new Date().toISOString(), user: { firstName: 'John', lastName: 'Doe' } },
        { id: '2', type: 'WITHDRAWAL', amount: 500, status: 'PENDING', createdAt: new Date(Date.now() - 3600000).toISOString(), user: { firstName: 'Jane', lastName: 'Smith' } },
        { id: '3', type: 'PAYOUT', amount: 1200, status: 'FAILED', createdAt: new Date(Date.now() - 86400000).toISOString(), user: { firstName: 'Mike', lastName: 'Johnson' } },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="page-title">Transactions</h1>

      <div className="glass">
        <div className="card-header">
          <div className="action-bar" style={{ margin: 0 }}>
            <div style={{ position: 'relative' }}>
              <Search size={18} style={{ position: 'absolute', left: 12, top: 12, color: 'var(--text-secondary)' }} />
              <input type="text" placeholder="Search transactions..." className="search-input" style={{ paddingLeft: 40 }} value={search} onChange={e => setSearch(e.target.value)} />
            </div>
            <select className="dropdown" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
              <option value="">All Status</option>
              <option value="COMPLETED">Completed</option>
              <option value="PENDING">Pending</option>
              <option value="FAILED">Failed</option>
            </select>
          </div>
        </div>

        <div className="table-container" style={{ border: 'none', borderRadius: '0 0 16px 16px' }}>
          {loading ? (
            <div className="loader-container"><div className="spinner"></div></div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>User</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {transactions
                  .filter(tx => !search || `${tx.user?.firstName} ${tx.user?.lastName} ${tx.id}`.toLowerCase().includes(search.toLowerCase()))
                  .filter(tx => !statusFilter || tx.status === statusFilter)
                  .map(tx => (
                  <tr key={tx.id || tx._id}>
                    <td style={{ fontFamily: 'monospace', color: 'var(--accent)' }}>{(tx.id || tx._id || '').substring(0, 8)}...</td>
                    <td style={{ fontWeight: 500 }}>{tx.user?.firstName} {tx.user?.lastName}</td>
                    <td style={{ color: 'var(--text-secondary)' }}>{tx.type}</td>
                    <td style={{ fontWeight: 600 }}>${tx.amount}</td>
                    <td>
                      <span className={`badge ${(tx.status || 'pending').toLowerCase()}`}>
                        {tx.status || 'PENDING'}
                      </span>
                    </td>
                    <td style={{ color: 'var(--text-secondary)' }}>
                      {tx.createdAt ? format(new Date(tx.createdAt), 'MMM dd, yyyy HH:mm') : 'N/A'}
                    </td>
                  </tr>
                ))}
                {transactions.filter(tx => !search || `${tx.user?.firstName} ${tx.user?.lastName} ${tx.id}`.toLowerCase().includes(search.toLowerCase())).filter(tx => !statusFilter || tx.status === statusFilter).length === 0 && (
                  <tr><td colSpan="6" style={{ textAlign: 'center', padding: '32px', color: 'var(--text-secondary)' }}>No transactions found.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
